
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 5C2.567 5 1 6.567 1 8.5V9.5C1 11.433 2.567 13 4.5 13C5.32843 13 6 13.6716 6 14.5V15.5C6 16.3284 5.32843 17 4.5 17H4C3.44772 17 3 16.5523 3 16H1C1 17.6569 2.34315 19 4 19H4.5C6.433 19 8 17.433 8 15.5V14.5C8 12.567 6.433 11 4.5 11C3.67157 11 3 10.3284 3 9.5V8.5C3 7.67157 3.67157 7 4.5 7H5C5.55228 7 6 7.44772 6 8H8C8 6.34315 6.65685 5 5 5H4.5ZM13 5C10.7909 5 9 6.79086 9 9V15C9 16.8874 10.3072 18.4695 12.0656 18.8903C12.0224 18.5998 12 18.3025 12 18C12 17.5879 12.0415 17.1855 12.1207 16.7968C11.457 16.4714 11 15.7891 11 15V9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9V12.8027C15.6074 12.4513 16.2821 12.2034 17 12.083V9C17 6.79086 15.2091 5 13 5ZM21 5V12.8027C20.3926 12.4513 19.7179 12.2034 19 12.083V5H21ZM13.9695 13.5553C13.4709 14.0077 13.0488 14.5428 12.7248 15.139L12.2929 14.7071L13.7071 13.2929L13.9695 13.5553ZM17.25 14V17.25H14V18.75H17.25V22H18.75V18.75H22V17.25H18.75V14H17.25Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowSqLaddedFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
